<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
/deep/.el-table-column--selection .cell{padding-right: 10px;}
/deep/.el-form-item__content .el-input {width: 400px;}
/deep/.el-form-item__label {width: 10%;margin-left: 100px;}
/deep/.el-form-item__content img {width: 148px;height: 148px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column label="类型" width="80">
            <template slot-scope="scope">{{ scope.row.dispc }}</template>
          </el-table-column>
          <el-table-column prop="level" label="级别" width="50"></el-table-column>
          <el-table-column label="图片" width="140">
            <template slot-scope="scope">
              <img :src="scope.row.thumb" width="80px" height="80px" class="head_pic"/>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column label="价格" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.price == '0'"> 暂无 </span>
              <span v-else>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" width="180">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="hits" label="浏览" width="70">
          </el-table-column>
          <el-table-column prop="comments" label="评论" width="70">
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 18, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button type="success" @click="addfn4()" class="elbtn">添加</el-button>
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 18)">批量删除</el-button>
      </div>
    </div>
    <!-- 修改弹框 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogVisible"
      :width="widthCSH"
      title="修改矿业设备信息"
      class="mydialog">
      <QyzsKysbUpdate :tjcpID='tjcpID' @cancle="cancle" @getList="getList" v-if="dialogVisible"></QyzsKysbUpdate>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import QyzsKysbUpdate from '../QyxxUpdate/QyzsKysbUpdate.vue'
import filters from '../../../method/filter'
import '../../../../backer/method/dialog'
export default {
  mixins: [filters],
  props: ['companyName', 'userData'],
  components: {
    QyzsKysbUpdate
  },
  data()
  {
    return {
      tjcpID: null,
      //列表数据
      tableData: [],
      //弹框显隐
      dialogVisible: false,
      widthCSH: '75%',
      // 多删id数组
      multipleSelection: []
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '4')
          this.getList()
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      if (!window.userData.company) return
      let paras1 = {cmd: 'query', _major: 11, _minor: 18,  _exp: `company = '${window.userData.company}'`, orderby: 'addtime desc'}
      window.post.getPost(paras1).then((rets) =>
      {
        let temp = []
        rets.forEach((item) =>
        {
          temp.push({
            id: item.id,
            dispc: item.dispc,
            level: item.level,
            title: item.title,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
            addtime: item.addtime,
            edittime: item.edittime,
            hits: item.hits,
            comments: item.comments
          })
          this.tableData = temp
        })
      })
    },
    //点击修改
    updatafn(row)
    {
      this.tjcpID = row.id
      this.dialogVisible = true
    },
    cancle()
    {
      this.dialogVisible = false
      this.getList()
    },
    addfn4()
    {
      if (this.userData.groupid === '5')
        this.$emit('addTab2')
      else
        this.$emit('addTab4')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/QyxxLB/QyzsKysbLB.vue